import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import outcomeOfConsultationForm from '../../clients/detail/dndForm/outcomeOfConsultationForm';
import type { OutcomeOfConsultationStatistic as OutcomeOfConsultationStatisticType } from '../../common/types/statistics/dndStatistics';

type Props = {
  numberOfClients: number;
  clientStatistics: OutcomeOfConsultationStatisticType;
};

function OutcomeOfConsultationStatistic({ numberOfClients, clientStatistics }: Props) {
  const appointmentTreatmentOptions = outcomeOfConsultationForm.fields.find(
    (field) => field.key === 'appointmentTreatmentOptions'
  );

  return (
    <Stack direction='column' mt={1}>
      <Typography fontSize='1.1rem' fontWeight='bold'>
        Ergebnisse der telefonischen Beratung
      </Typography>
      <Stack>
        <Typography>Anzahl der Klient*innen: {numberOfClients}</Typography>
        <Typography>
          Anzahl der vereinbarten Beratungstermine: {clientStatistics.numberOfAppointmentForCounselling}
        </Typography>
        <Stack my={1}>
          {appointmentTreatmentOptions != null && appointmentTreatmentOptions.label != null && (
            <Typography fontWeight='bold'>{appointmentTreatmentOptions.label}</Typography>
          )}
          {appointmentTreatmentOptions != null &&
            appointmentTreatmentOptions.fieldTypes === 'select' &&
            Object.keys(clientStatistics.appointmentTreatmentOptions).map((statisticKey) => {
              const option = appointmentTreatmentOptions.options.find((option) => option.value === statisticKey);

              return option == null ? null : (
                <Typography key={statisticKey}>
                  {option.label}: {clientStatistics.appointmentTreatmentOptions[statisticKey]}
                </Typography>
              );
            })}
        </Stack>
        <Typography>Anzahl der psychosoziale Beratungen: {clientStatistics.numberOfPsychosocialCounselling}</Typography>
        <Typography>Anzahl der Krisenintervention: {clientStatistics.numberOfCrisisintervention}</Typography>
        <Typography>Anzahl der Ernährungsberatungen: {clientStatistics.numberOfNutritionCounselling}</Typography>
        <Typography>Informations Themen: {clientStatistics.informationTopics.join(', ')}</Typography>
        <Typography>Sonstige Themen: {clientStatistics.otherTopics.join(', ')}</Typography>
      </Stack>
    </Stack>
  );
}

export default OutcomeOfConsultationStatistic;
